import { render, staticRenderFns } from "./MappingMS.vue?vue&type=template&id=bd5fa76c"
import script from "./MappingMS.vue?vue&type=script&lang=js"
export * from "./MappingMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports